// En este fichero defeniremos los IDs de las acciones de nuestros plugins.
export const ZOHO_CREATE_LEAD_TO_CONTACT_ACTION_ID = "e7bf27f4-723a-4ce9-933d-26ce03754d37";
export const ZOHO_REFRESH_ACCESS_TOKEN_ACTION_ID = "7d930cdb-4fde-4111-9726-26cd775ff379";
export const ZOHO_GENERATE_ACCESS_TOKEN_ACTION_ID = "49db13af-26b2-4a54-a2d5-55659e82d7ff";
export const ZOHO_GET_FIELDS_FROM_API_LEADS_TO_CONTACT_ACTION_ID = "a8924917-8302-4df0-bd35-1014385146f0";
export const ZOHO_PLUGIN_ID = "97911750-50d8-486b-b37e-00cffb65dead";

export const HTTP_REQUEST_MATCHING_RESPONSE_ACTION_ID = "94bfe454-8284-42ce-a28d-e5e49d353f12";

